import { Component, OnInit, Input, forwardRef, Injector, AfterContentInit, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';

import { BsLocaleService, BsDatepickerViewMode, BsDatepickerDirective  } from 'ngx-bootstrap/datepicker';
import { ptBrLocale } from 'ngx-bootstrap/locale';

import { Moment } from 'src/app/shared/utils';

import { FieldBaseComponent } from 'src/app/shared/components/field-base/field-base.component';

@Component({
  selector: 'app-field-input-date',
  templateUrl: './field-input-date.component.html',
  styleUrls: ['./field-input-date.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => FieldInputDateComponent), multi: true },
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => FieldInputDateComponent), multi: true }
  ],
})
export class FieldInputDateComponent extends FieldBaseComponent implements OnInit, AfterContentInit {

  @ViewChild('dp') dp: BsDatepickerDirective;

  @Input() layout: 'default' | 'ngx' | 'primeface' = 'ngx';
  @Input() maxNow: boolean = false;
  @Input() minNow: boolean = false;
  @Input() placeholder: string | null;
  @Input() viewMode: BsDatepickerViewMode = 'day';
  @Input() minDate: Date = new Date(0, 0, 0);
  @Input() maxDate: Date = new Date(3000, 12, 31);
  @Input() disabledDates: Date[] = [];
  @Input() timeOnly = false;

  @Input() inputClass: string | null;

  @Input() set format(value: string) {
    if (value === 'ecm')  {
      this.ecm = true;
      return;
    }

    if (!!value) {
      this._format = value;
    }

    // Se tiver hora no formato
    if (!!value && value.toLowerCase().indexOf('hh') !== -1) {
      this.writeFormat = 'YYYY-MM-DD' + value.slice(10);
    }
  }

  private ecm: boolean = false;
  private _format: string = 'DD/MM/YYYY';
  private writeFormat: string = 'YYYY-MM-DD';

  constructor(
    protected injector: Injector,
    private localeService: BsLocaleService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.localeService.use(ptBrLocale.abbr);
  }

  ngAfterContentInit(): void {
    super.ngAfterContentInit();

    if (this.maxNow) {
      this.maxDate = new Date();
    }

    if (this.minNow) {
      this.minDate = new Date();
    }
  }

  writeValue(value: any): void {
    if (value) {
      let mDate = Moment(this.ecm ? value.date : value);

      if (value && (!mDate || !mDate.isValid())) {
        mDate = Moment(value, [this.writeFormat]);
      }

      if (mDate && mDate.isValid()) {
        if (this.layout === 'default') {
          super.writeValue(mDate.format(this.writeFormat));
        } else {
          super.writeValue(mDate.toDate());
        }
        return;
      }
    }

    super.writeValue(null);
  }

  valueChange(date: Date): void {
    let value = null;
    if (!!date) {
      const mDate = Moment(date);
      if (!mDate.isValid()) { return; }

      if (this.ecm) {
        value = { date: mDate.format() };
      } else if (!!this._format) {
        value = mDate.format(this.writeFormat);
      } else {
        value = mDate.format();
      }
    }

    super.valueChange(value);
  }

  getBsConfig() {
    return {
      dateInputFormat: this._format,
      selectFromOtherMonth: true,
      containerClass: 'theme-dark-blue',
      minMode: this.viewMode,
      isAnimated: true,
      adaptivePosition: true,
      showWeekNumbers: false,
      showTodayButton: true,
      todayPosition: 'center',
      todayButtonLabel: 'Hoje',
      customTodayClass: 'datepiker-today-class'
    };
  }

  toggle(): void {
    if (this.dp) {
      this.dp.toggle();
    }
  }

}
